<div class="d-flex align-items-center justify-content-between px-3 py-2">
  <div class="d-flex gap-5 align-items-center">
    <div class="d-flex align-items-center gap-2">
      <label for="sorting">{{ 'action.sortBy' | transloco }}</label>
      <div>
        <select [formControl]="sorting" (change)="updateSorting()" class="form-select" id="sorting">
          <option selected value="lastModifiedDateTime.desc">{{ 'general.lastModified' | transloco }}</option>
          <option value="establishedDate.desc.nullsLast">{{ 'freightDocument.establishedDate' | transloco }}</option>
          <option value="agreedDateOfTakingOver.desc.nullsLast">{{ 'freightDocument.pickupDate' | transloco }}</option>
          <option value="agreedDateTimeOfDelivery.desc.nullsLast">{{ 'freightDocument.deliveryDateAgreed' | transloco }}</option>
        </select>
      </div>
    </div>
  </div>

  <div class="d-flex" ngbDropdown placement="bottom-right" *ngIf="userPermissions$ | async as permissions">
    <button type="button" ngbDropdownToggle class="button-tertiary">
      {{ 'action.more'  | transloco }}
    </button>
    <div ngbDropdownMenu>
      <button type="button" ngbDropdownItem class="ps-0" *ngIf="permissions.importDocuments" (click)="importDocumentsClicked.next()">
        <span class="icon icon-add-new-active me-1"></span>
        {{ 'freightDocument.importButton' | transloco }}
      </button>
      <button type="button" ngbDropdownItem class="ps-0" (click)="exportDocumentsClicked.next()">
        <span class="icon icon-download me-1"></span>
        {{ 'transportOperations.fds.export' | transloco }}
      </button>
      <button type="button" ngbDropdownItem class="ps-0" (click)="updateViewSettings()">
        <span class="icon icon-active me-1"></span>
        {{ 'documents.viewSettings.action' | transloco }}
      </button>
    </div>
  </div>
</div>
